import { isEducationFirst } from "../../router/sectionOrder";
import { NavigationFlow, NavigationList } from "../../seed/navigation";

const navigationFlow = new NavigationFlow();

let yearsOfExperience = localStorage.getItem("yearsOfExperience");
let templateName = localStorage.getItem("templateName");

if (templateName === null || templateName === undefined) {
	templateName = "fresher_template";
	localStorage.setItem("templateName", templateName);
}

if (yearsOfExperience === null || yearsOfExperience === undefined) {
	yearsOfExperience = "No Experience";
	localStorage.setItem("yearsOfExperience", yearsOfExperience);
}

let currentNav = localStorage.getItem("currentNav");
currentNav = "contact-information";
localStorage.setItem("currentNav", currentNav);
if (currentNav === null || currentNav === undefined || currentNav === "undefined" || currentNav === "heading") {
	currentNav = "contact-information";
	localStorage.setItem("currentNav", currentNav);
}

// The level decides which of the two flows the builder walks: education first for
// a reader with no jobs yet, work history first for everyone else.
const flow = navigationFlow.getFlow(isEducationFirst(yearsOfExperience));

let navFlow = new NavigationList(flow, flow);

let finalValue = navFlow.current.value.url;
let nextValue = navFlow.current;

while (finalValue !== currentNav || finalValue === "review") {
	nextValue = navFlow.current.next;
	navFlow.current = nextValue === null || nextValue === undefined ? navFlow.current : nextValue;
	finalValue = navFlow.current.value.url;
}

export default function TemplateSelectionReducer(
	template = {
		selectedTemplate: {
			yearsOfExperience: yearsOfExperience,
			templateName: templateName,
		},
		navigationFlow: navFlow,
	},
	action,
) {
	switch (action.type) {
		case "CHANGE_TEMPLATE_DETAILS":
			// Return a new object: mutating `template` in place kept the same
			// reference, so useSelector subscribers never saw the change.
			return {
				...template,
				selectedTemplate: action.payload.selectedTemplate,
				navigationFlow: action.payload.navigationFlow,
			};

		default:
			return template;
	}
}
// const noExperienceList = new NavigationList(fresherFlow, template.navigationFlow.current);
